<template lang="pug">
v-main
  v-container
    v-card
        v-toolbar.elevation-0
            v-toolbar-title Upload Account
            v-spacer
            v-btn(outlined class="text-capitalize" color="blue" href="files/template-bulk-users.csv" donwload)
              v-icon.mr-2 cloud_download
              | Download Template 
        v-divider
        v-card-text
            v-form.my-2
                v-row(no-gutters)
                    v-col(cols="3") 
                        v-subheader(color="black") Business Unit
                    v-col(cols="5")
                        v-autocomplete(
                            ref="business_units",
                            :items="business_units"
                            v-model="bu"
                            label="Business Unit"
                            item-text="name"
                            item-value="id"
                        )

                v-row(no-gutters)
                    v-col(cols="3") 
                        v-subheader(color="black") Upload File
                    v-col(cols="5")
                        v-file-input(
                            label="Upload File (Max Size: 5 MB. Format: csv)."
                            v-model="file"
                            accept=".csv"
                            @change="handleFileUpload( $event )"
                            :rules="[rules.required, rules.max]",
                            ref="fileupload"
                            hint="*Accounts created via upload will automatically become role users."
                            persistent-hint
                        )
                v-alert(dismissible color="red" class="mt-5" dark v-model='csvFalse' transition="scale-transition" ) The file you uploaded has an error, please fix your data error!
                v-toolbar(color="grey lighten-4 elevation-0 mt-5" height="48") Preview File

                v-data-table(
                    v-if="parsed"
                    class="mt-2"
                    :headers="dataHeaders",
                    :items="content.data",
                )
                v-data-table(
                    v-else-if="csvFalse"
                    class="mt-2"
                    :headers="csvFalseHeader"
                    :items="csvFalseData"
                    :item-class= "row_classes"
                )

                div(v-else class="text-center no-data")
                    img(src="../assets/no-data.png" class="mb-1")
                    h3 No Data 
                    p(color="grey lighten-4") Upload file and preview
                
                v-card-actions.my-8
                    v-btn(
                        v-if="$store.state.dataUsers.role=='super_user'"
                        @click="$router.push('/users-general')" 
                        class="elevation-0 custom__padding-btn") Cancel
                    v-btn(
                        v-if="$store.state.dataUsers.role=='admin'"
                        @click="$router.push('/users')" 
                        class="elevation-0 custom__padding-btn") Cancel
                    v-btn(
                        :disabled="!formIsValid || csvFalse || errorData"
                        class="elevation-0 custom__padding-btn"
                        color="blue-secondary"
                        @click="create()"
                    ) Submit

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import Papa from 'papaparse';
import axios from "axios";
import { mapState } from "vuex";
export default {
  data: () => ({
    bu: "",
    business_units: [],
    file: null,
    content: [],
    parsed: false,
    overlay: false,
    dataHeaders: [
        { text: "Full Name", value: "full_name" },
        { text: "Alias Name", value: "alias" },
        { text: "Email", value: "email" },
        { text: "Position", value: "position" },
        { text: "Email Busines Unit", value: "email_bu" },
        { text: "Phone Number BU", value: "msisdn_bu" },
    ],
    rules: {
      required: (value) => !!value || "This field is required.",
      max: (value) => value.size < 5000000 ||
        "File size exceeds the limit ! (Maximum 5 MB)",
    },
    csvFalse: false,
    csvFalseHeader: [
        { text: "Error Description", value: "reason" },
        { text: "Full Name", value: "data.full_name" },
        { text: "Alias Name", value: "data.alias" },
        { text: "Email", value: "data.email" },
        { text: "Position", value: "data.position" },
        { text: "Email Business Unit", value: "data.email_bu" },
        { text: "Phone Number BU", value: "data.msisdn_bu" },
    ],
    csvFalseData: [],
    errorData: false
  }),
  mounted() {
    this.getBisnisUnit()
  },
  computed: {
    ...mapState(["loadingData", "showDrawer", "dataUsers"]),
    formIsValid() {
      return this.bu && this.file;
    },
  },
  methods: {
    handleFileUpload( event ){
      this.file = event;
      this.parseFile();
    },
    parseFile(){
        if ( this.file != null ) {
          this.overlay = true;
            Papa.parse( this.file, {
                header: true,
                skipEmptyLines: true,
                complete: function( results ){
                    for(let dt of results.data) {
                      if (dt) {
                        dt.alias = dt.alias.trim()
                        dt.email = dt.email.trim()
                        dt.email_bu = dt.email_bu.trim()
                        dt.full_name = dt.full_name.trim()
                        dt.msisdn_bu = dt.msisdn_bu.trim()
                        dt.position = dt.position.trim()
                      }
                    }
                    this.overlay = false;
                    this.content = results;
                    this.parsed = true;
                    this.csvFalse = false
                    this.errorData = false
                }.bind(this)
            });
        } 
    },
    getBisnisUnit() {
        let token = localStorage.getItem("token");

        axios
        .get(process.env.VUE_APP_API+`/users/info`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {

            if ( res.data.data.role == 'super_user' ) {
                axios
                .get(process.env.VUE_APP_API + `/business-unit/list/active`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((res) => {
                    let dataBU = res.data.data;
                    for (const item of dataBU) {
                        this.business_units.push({name: item.name, id: item._id});
                    }
                })
            } else if ( res.data.data.role == 'admin' ) {
                axios
                .get(process.env.VUE_APP_API + `/business-unit/list`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((res) => {
                    let dataBU = res.data.data;
                    for (const item of dataBU) {
                        this.business_units.push({name: item.bu_name, id: item.id});
                    }
                })
            }
        })
        .catch((err) => {
          if (err.response.status == 401 || err.response.status == 403) {
            return this.$router.push("/logout");
          }
        })
    },
    create() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      let formData = new FormData();
      formData.append("bu_id", this.bu);
      formData.append("file", this.file);

      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/csv/import-user`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };

      axios(config)
        .then((res) => {
          this.overlay = false;
          if (res.data.status == 200) {
            this.$toasted.success("Success, Data successfully added", {
              icon: "check_circle",
            });
            return this.$router.push("/users");
          }
        })
        .catch((message) => {
          this.overlay = false;
          this.showError(message);
        });
    },
    showError(err) {
        this.file = null;
        if ( Array.isArray(err.response.data.message) == true ) {
          this.parsed = false
          this.csvFalse = true
          this.csvFalseData = err.response.data.message;
        } else {
          this.errorData = true;
          this.$toasted.error(err.response.data.message, {icon: 'error'})
        }
    },
    row_classes(item) {
        if( item.reason != '' ) {
          return "custom-tr"
        }
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div.v-input__prepend-outer {
  display: none !important;
}

div.v-responsive__sizer {
  padding-bottom: 0;
}

.no-data{
    margin-top: 2rem;
    margin-bottom: 6rem;
}

tr.custom-tr td:first-child{
  color: red;
}
</style>